/** Paleta para comparação de equipamentos */
export const EQUIPMENT_COLORS = [
  "#1c4220",
  "#8fad15",
  "#2a7f9e",
  "#c47a00",
  "#8b3a62",
  "#3d6b4f",
  "#d35400",
  "#2980b9",
  "#7d3c98",
  "#16a085",
  "#c0392b",
  "#34495e",
];

/** Regras de modelo a partir do serial (mesmo padrão do restante do SGU) */
export const EQUIPMENT_MODEL_RULES = [
  { test: (serial) => serial.startsWith("PRAR"), code: "PRAR", label: "Secador (PRAR)" },
  { test: (serial) => serial.startsWith("SBAG"), code: "SBAG", label: "Silo bolsa (SBAG)" },
  { test: (serial) => serial.includes("SEMT"), code: "SEMT", label: "SEMT" },
  { test: (serial) => serial.includes("SIMT"), code: "SIMT", label: "SIMT" },
  { test: (serial) => serial.includes("BIMT"), code: "BIMT", label: "BIMT" },
  { test: (serial) => serial.includes("CPMT"), code: "CPMT", label: "CPMT" },
  { test: (serial) => serial.includes("EEMT"), code: "EEMT", label: "EEMT" },
  { test: (serial) => serial.includes("ALRM"), code: "ALRM", label: "Alarme" },
  { test: (serial) => serial.includes("RODZ"), code: "RODZ", label: "Rodízio" },
];

export const getEquipmentColor = (index) =>
  EQUIPMENT_COLORS[index % EQUIPMENT_COLORS.length];

export const normalizeSerial = (serial) => {
  const value = String(serial || "").trim();
  return value ? value.toUpperCase() : "";
};

export const serialsMatch = (a, b) => {
  const left = normalizeSerial(a);
  const right = normalizeSerial(b);
  return Boolean(left && right && left === right);
};

export const getMeasurementSerial = (item) => {
  const raw =
    item?.serialnumber ||
    item?.serial ||
    item?.equipment ||
    item?.nameEquipament ||
    null;
  if (raw === null || raw === undefined || raw === "") return null;
  return String(raw).trim();
};

export const dataHasEquipmentIdentity = (dataList = []) =>
  dataList.some((item) => Boolean(getMeasurementSerial(item)));

export const getEquipmentModel = (serial) => {
  const normalized = String(serial || "").trim().toUpperCase();
  if (!normalized) {
    return { code: "OUTROS", label: "Outros" };
  }

  const matched = EQUIPMENT_MODEL_RULES.find((rule) => rule.test(normalized));
  if (matched) {
    return { code: matched.code, label: matched.label };
  }

  const prefix = normalized.substring(0, 4);
  return { code: prefix || "OUTROS", label: prefix || "Outros" };
};

export const collectAvailableModels = (companies = []) => {
  const map = new Map();

  companies.forEach((company) => {
    (company?.equipments || []).forEach((serial) => {
      const model = getEquipmentModel(serial);
      if (!map.has(model.code)) {
        map.set(model.code, model);
      }
    });
  });

  return [...map.values()].sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));
};

export const collectAvailableModelsFromSerials = (serials = []) => {
  const map = new Map();

  serials.forEach((serial) => {
    const model = getEquipmentModel(serial);
    if (!map.has(model.code)) {
      map.set(model.code, model);
    }
  });

  return [...map.values()].sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));
};

export const serialMatchesModels = (serial, selectedModels) => {
  if (!selectedModels?.size) return true;
  const { code } = getEquipmentModel(serial);
  return selectedModels.has(code);
};

export const buildEquipmentMappingsForCompanies = (
  companies = [],
  companyIds = [],
  selectedModels = null
) => {
  const idSet = new Set(companyIds);
  return companies
    .filter((company) => idSet.has(company._id))
    .flatMap((company) =>
      (company.equipments || [])
        .filter((serial) => serialMatchesModels(serial, selectedModels))
        .map((equipment) => ({
          companyId: company._id,
          equipment: String(equipment).trim(),
        }))
    );
};

export const buildEquipmentOptions = (equipmentList, empresasAll = [], allData = []) => {
  if (!equipmentList?.length) return [];

  return equipmentList.map((mapping, index) => {
    const serial = String(mapping.equipment || "").trim();
    const unit = empresasAll.find((u) => u._id === mapping.companyId);
    const sample = allData.find((item) =>
      serialsMatch(getMeasurementSerial(item), serial)
    );
    const model = getEquipmentModel(serial);

    return {
      serial,
      companyId: mapping.companyId,
      unitName: unit?.name || "",
      label: sample?.nameEquipament || serial,
      model: model.code,
      modelLabel: model.label,
      color: getEquipmentColor(index),
    };
  });
};

export const filterDataBySerials = (dataList, selectedSerials) => {
  if (!dataList?.length) return [];
  if (!selectedSerials?.size) return [];

  // Sem identidade no payload: não dá para filtrar por equipamento — mantém os dados
  if (!dataHasEquipmentIdentity(dataList)) {
    return dataList;
  }

  const selected = [...selectedSerials]
    .map((serial) => String(serial).trim())
    .filter(Boolean);

  return dataList.filter((item) => {
    const serial = getMeasurementSerial(item);
    return serial && selected.some((key) => serialsMatch(serial, key));
  });
};
